import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Row, Col, Typography, Spin, Button, Upload, notification, Icon } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import ApiCaller from '../../../utils/api-caller';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import './adminHotelDescription.css';

const { Text } = Typography;

@inject(
    'loginStore',
    'CmsLanguageStore',
    'webSettingStore',
    'CmsHotelDescStore'
)
@observer
class AdminHotelDescriptionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadingLogoState: false,
            uploadingBannerState: false
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
            if (!response) {
                this.props.history.push('/admin/login');
            }
        });

        this.props.CmsLanguageStore.getActives();
        this.props.CmsHotelDescStore.getData();
    }

    // ON UPLOAD

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUploadLogo = (file) => {
        const { t } = this.props;
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: t('Failed to upload image'),
                description: t('You can only upload JPG/PNG file!'),
                placement: 'bottomRight',
            });
        }

        const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
        if (!isLessThan10Mb) {
            notification.warning({
                message: t('Failed to upload image'),
                description: t('Image must smaller or equal to 1MB!'),
                placement: 'bottomRight',
            });
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.setState({ uploadingLogoState: true });
        }

        return isJpgOrPng && isLessThan10Mb;
    }

    beforeUploadBanner = (file, id) => {
        const { t } = this.props;
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: t('Failed to upload image'),
                description: t('You can only upload JPG/PNG file!'),
                placement: 'bottomRight',
            });
        }

        const isLessThan10Mb = file.size / 1024 / 1024 <= 1;
        if (!isLessThan10Mb) {
            notification.warning({
                message: t('Failed to upload image'),
                description: t('Image must smaller or equal to 1MB!'),
                placement: 'bottomRight',
            });
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.CmsHotelDescStore.setbannerUrlIsLoading(id, true);
        }

        return isJpgOrPng && isLessThan10Mb;
    }

    updateLogoUrlOnChange = (info, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsHotelDescStore.setlogoUrl('');
                return;
            }

            if (info.file.status === 'done') {
                const category = 'HotelDescription';
                const titleName = title || 'Default';

                ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsHotelDescStore.setlogoUrl(response.imageUrl);
                    this.setState({ uploadingLogoState: false });
                })
            }
        }
    }

    updateBannerUrlOnChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.CmsHotelDescStore.setbannerUrlById(id, '')
                return;
            }

            if (info.file.status === 'done') {
                const category = 'HotelDescription';
                const titleName = title || 'Default';

                ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.CmsHotelDescStore.setbannerUrlById(id, response.imageUrl)
                    this.props.CmsHotelDescStore.setbannerUrlIsLoading(id, false);
                })
            }
        }
    }

    // ON CLICK

    update = () => {
        this.props.CmsHotelDescStore.update().then(() => {
            this.props.CmsHotelDescStore.getData();
        });
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;
        const { t } = this.props;

        const {
            hotelDesc,
            bannerImages,
            loading
        } = this.props.CmsHotelDescStore;

        const uploadLogoButton = (
            <div>
                <Icon type={this.state.uploadingLogoState ? 'loading' : 'plus'} />
                <div className='ant-upload-text'>{t('Upload Logo')}</div>
            </div>
        );

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            {
                                hotelDesc
                                    ?
                                    <>
                                        <MainContainer title={t('Hotel Description')} menukey='hoteldescription'>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Card>
                                                        <Spin spinning={loading}>
                                                            <Row className='adminHotelDescription-row-container'>
                                                                <Col span={24} className='adminHotelDescription-col-label'>
                                                                    <Text className='adminHotelDescription-text-label'>{t('Hotel Logo')}</Text><br />
                                                                    <Text className='adminHotelDescription-text-label-detail'>{t('Recommendation 120 x 80, Maximum Size is 1MB')}</Text>
                                                                </Col>
                                                                <Col span={24} className='adminHotelDescription-col-input'>
                                                                    <Upload
                                                                        listType='picture-card'
                                                                        className='avatar-uploader'
                                                                        showUploadList={false}
                                                                        customRequest={this.dummyRequest}
                                                                        beforeUpload={this.beforeUploadLogo}
                                                                        onChange={(info) => this.updateLogoUrlOnChange(info, 'HotelLogo')}
                                                                    >
                                                                        {
                                                                            hotelDesc.logoUrl !== ''
                                                                                ?
                                                                                <img src={hotelDesc.logoUrl} alt='avatar' className='stm-height-100 stm-width-auto' />
                                                                                :
                                                                                uploadLogoButton
                                                                        }
                                                                    </Upload>
                                                                    {
                                                                        hotelDesc.logoUrl !== ''
                                                                            ?
                                                                            <div>
                                                                                <Button onClick={() => this.props.CmsHotelDescStore.setlogoUrl('')}>{t('Delete Hotel Logo')}</Button>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </Col>

                                                                <>
                                                                    {
                                                                        bannerImages.map(image => {
                                                                            return (
                                                                                <>
                                                                                    <Col span={24} className='adminHotelDescription-col-label stm-padding-bottom-4'>
                                                                                        <Text className='adminHotelDescription-text-label'>{image.url === '' ? t('Create') : t('Update')} {t('Hotel Banner')}</Text><br />
                                                                                        <Text className='adminHotelDescription-text-label-detail'>{t('Recommendation 375 x 240, Maximum Size is 1MB')}</Text>
                                                                                    </Col>
                                                                                    <>
                                                                                        {
                                                                                            image.url === ''
                                                                                                ?
                                                                                                null
                                                                                                :
                                                                                                <Col span={24} className='adminHotelDescription-col-label stm-padding-bottom-4'>
                                                                                                    <Button type='danger' onClick={() => this.props.CmsHotelDescStore.removeBannerImageById(image.id)}>{t('Delete')}</Button>
                                                                                                </Col>
                                                                                        }
                                                                                    </>
                                                                                    <Upload
                                                                                        listType='picture-card'
                                                                                        className='avatar-uploader'
                                                                                        showUploadList={false}
                                                                                        customRequest={this.dummyRequest}
                                                                                        beforeUpload={(info) => this.beforeUploadBanner(info, image.id)}
                                                                                        onChange={(info) => this.updateBannerUrlOnChange(info, image.id, 'HotelBanner')}
                                                                                    >
                                                                                        {
                                                                                            image.url !== ''
                                                                                                ?
                                                                                                <img src={image.url} alt='avatar' className='updatehotelfacility-img' />
                                                                                                :
                                                                                                <div>
                                                                                                    <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                                                    <div className='ant-upload-text'>{t('Upload')}</div>
                                                                                                </div>}
                                                                                    </Upload>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }
                                                                </>

                                                                <Col span={24} className='stm-margin-bottom-16 stm-margin-top-16 stm-font-size-14 stm-line-height-20'>
                                                                    <Row>
                                                                        <Col span={24} className='adminHotelDescription-col-label stm-margin-bottom-16'>
                                                                            <Text className='adminHotelDescription-text-label'>{t('Description')}</Text><br />
                                                                        </Col>
                                                                        <>
                                                                            {
                                                                                activeLanguages.map(lang => {
                                                                                    return (
                                                                                        <Col key={lang.id} span={24} className='stm-margin-bottom-16 stm-font-size-14 stm-line-height-20 stm-padding-left-16'>
                                                                                            <Row>
                                                                                                <Col span={6}>{lang.originalName}</Col>
                                                                                                <Col span={18} className=''>
                                                                                                    <>
                                                                                                        {
                                                                                                            hotelDesc.hotelDescLanguages.find(fi => fi.languageId === lang.id)
                                                                                                                ?
                                                                                                                <CKEditor
                                                                                                                    editor={ClassicEditor}
                                                                                                                    data={hotelDesc.hotelDescLanguages.find(fi => fi.languageId === lang.id).description}
                                                                                                                    onChange={(event, editor) => {
                                                                                                                        const data = editor.getData();
                                                                                                                        this.props.CmsHotelDescStore.setdescription(lang.id, data)
                                                                                                                    }}
                                                                                                                />
                                                                                                                :
                                                                                                                null
                                                                                                        }
                                                                                                    </>

                                                                                                </Col>
                                                                                            </Row>
                                                                                        </Col>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </>
                                                                    </Row>
                                                                </Col>

                                                                <Col span={24} className='adminHotelDescription-col-button'>
                                                                    <Button type='primary' onClick={this.update}>{t('Save')}</Button>
                                                                </Col>
                                                            </Row>
                                                        </Spin>
                                                    </Card>
                                                </Grid>
                                            </Grid>
                                        </MainContainer>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>

        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(AdminHotelDescriptionPage);